const ExternalUsers = () => import("./views/ExternalUsers.vue");
const ExternalUserEdit = () => import("./views/ExternalUserEdit.vue");

const route = "/externalUsers";

export default [
  {
    path: route,
    name: "externalUsers.list",
    component: ExternalUsers,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "externalUsers.create",
    component: ExternalUserEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:externalUserId/edit`,
    name: "externalUsers.edit",
    component: ExternalUserEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
